module.exports = __webpack_public_path__ + "img/home_bg_img.33ec1680.png";